import QuoteFormSuccess from './QuoteFormSuccess';

export default QuoteFormSuccess;
